/**
 * Un color de acento por tipo de trámite, para que el modal "elegir cliente o seguir sin él"
 * se sienta parte de la misma tarjeta que lo abrió. Mismos tonos que ya usan las tarjetas
 * `.acceso-card-{urlBase}` de assets/css/HomePage.css (el color del ícono/título de cada
 * variante), reusados acá como acento — no como fondo sólido: el header del modal es claro,
 * con un tinte muy suave del color (`${color}14` ≈ 8% opacity) y el ícono en un círculo con
 * ese mismo tinte, para que identifique el trámite sin taparlo con un bloque de color fuerte.
 *
 * La clave es el `urlBase` de cada entrada de caratulaRegistry.js; `pacto` es aparte porque
 * los pactos no tienen esa clave (no son una carátula).
 */
const coloresTramite = {
    rti: '#2563eb',
    art: '#D97706',
    pnc: '#0891B2',
    'amparo-pnc': '#0284C7',
    'amparo-ley-16986': '#0369A1',
    puam: '#E11D48',
    'plan-pago': '#65A30D',
    reajuste: '#EA580C',
    jubilacion: '#C026D3',
    pension: '#DB2777',
    'reajuste-pension': '#4F46E5',
    pacto: '#475569',
    cobro: '#0d9488',
    ganancias: '#16a34a',
    generico: '#475569',
    declaratoria: '#9f1239',
    // Dorado, como el botón de Reconocimiento de Servicios en Recepción (.atencion-btn-reconocimiento).
    reconocimiento: '#a16207',
    // Amparo por mora ante ANSES (V239). Clave propia, distinta de 'amparo-pnc': son dos trámites
    // distintos. El color es el de tipo_turno.AMPARO (V175).
    amparoanses: '#be123c',
};

const COLOR_POR_DEFECTO = '#2563eb';

export function colorPrimarioTramite(clave) {
    return coloresTramite[clave] || COLOR_POR_DEFECTO;
}

export default coloresTramite;
